// Slugs (task types, workflows) are 1-32 of `a-z`, `0-9`, `-` (docs/03). New items take one
// from their name until the admin types their own.
import { messages } from "../i18n";

export const SLUG_PATTERN = /^[a-z0-9-]{1,32}$/;

export function slugify(name: string): string {
  return name
    .toLowerCase()
    .normalize("NFKD")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "")
    .slice(0, 32)
    .replace(/-+$/, "");
}

export function slugProblem(slug: string): string | undefined {
  return SLUG_PATTERN.test(slug) ? undefined : messages().catalog.form.slugProblem;
}
